import { translations } from "../../i18n";

type Translation = (typeof translations)["de"];

function Testimonials({
  isVisible,
  t,
}: {
  isVisible: (id: string) => boolean;
  t: Translation["testimonials"];
}) {
  return (
    <section
      id="testimonials"
      data-animate
      className={`py-16 sm:py-24 md:py-32 bg-slate-900/30 transition-all duration-1000 ${
        isVisible("testimonials")
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-10"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-10 sm:mb-14 md:mb-20">{t.heading}</h2>

        <div className="grid md:grid-cols-3 gap-5 sm:gap-6 md:gap-8">
          {t.entries.map((testimonial, idx) => (
            <div
              key={idx}
              className="p-6 sm:p-8 bg-slate-800/50 border border-slate-700 rounded-2xl hover:border-orange-500/30 transition-all hover:translate-y-[-4px] hover:shadow-xl hover:shadow-orange-500/10 cursor-pointer group"
            >
              <p className="text-base sm:text-lg text-slate-300 mb-4 sm:mb-6 leading-relaxed group-hover:text-white transition-colors">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center font-bold text-lg group-hover:scale-110 transition-transform">
                  {testimonial.author.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold group-hover:text-orange-500 transition-colors">
                    {testimonial.author}
                  </p>
                  <p className="text-sm text-slate-400">{testimonial.role}</p>
                  <p className="text-xs text-slate-500">{testimonial.city}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;